import { PidController } from "../../../../../web-graphics";
//import { MeanPidCalculator } from "../../../../../web-graphics";
//import { MeanCalculator } from "../../../../../web-graphics";
import { ColumnLineSignalBuffer } from "./column-line-signal-buffer";

var abs = Math.abs;

export class VariableIsolineSignalBuffer extends ColumnLineSignalBuffer {
  // ppmm: pixels per mm, plotSize: { width: 0, height: 0}, windowSize: { width: 0, height: 0 }
  constructor(settings) {
    super(settings);
  }

  createBuffers() {
    super.createBuffers();

    this.isolineInPixels = null;
    this.newIsoline = null;
    //this.isolineCalculator = new MeanCalculator(8000);
    this.isolineCalculator = new PidController(0.03);
    //this.isolineCalculator = new MeanPidCalculator(0.03, 8000);
    this.filteredDataBuffer = [];
    this.filteredDataBuffer.length = this.graphicDataBuffer.length;
    this.filteredDataBuffer.fill(null);
  }

  getData(graphicDataIndex) {
    return this.filteredDataBuffer[graphicDataIndex];
  }

  getMinMax(beginIndex, endIndex) {
    if (beginIndex < 0 || endIndex < beginIndex || endIndex >= this.graphicDataBuffer.length) {
      return undefined;
    }
    let minValue = this.filteredDataBuffer[beginIndex];
    let maxValue = this.filteredDataBuffer[beginIndex];

    for (let i = beginIndex + 1; i < this.graphicDataBuffer.length; i++) {
      if (this.filteredDataBuffer[i] != null) {
        if (minValue == null || this.filteredDataBuffer[i] < minValue) {
          minValue = this.filteredDataBuffer[i];
        }
        if (maxValue == null || this.filteredDataBuffer[i] > maxValue) {
          maxValue = this.filteredDataBuffer[i];
        }
      }
    }
    return {
      min: minValue,
      max: maxValue
    };
  }

  setFilters(filters) {
    this.settings.filters = filters;
    this.updatePointsValues();
  }

  // data in UserUnits
  applyFilters(data) {
    let filteredData = data;
    for (let i = 0; i < this.settings.filters.length; i++) {
      filteredData = this.settings.filters[i].filter.exe(filteredData);
    }
    return filteredData;
  }

  setIsolineChangeAction(action) {
    this.onIsolineChangeAction = function (isoline) {
      action(isoline);
    }.bind(this);
  }

  tryUpdateMeanSignalValue() {
    //console.log(`[trySetNewIsoline] ${this.newIsoline} ${this.isoline} ${this.settings.isolineBorder}`);
    if (abs(this.newIsoline - this.isoline) > this.settings.isolineBorder) {
      //console.log(`updateIsoline: abs(${newIsoline} - ${this.isoline}) > ${this.settings.isolineBorder}`);
      this.isoline = this.newIsoline;
      if (this.onIsolineChangeAction !== undefined) {
        this.onIsolineChangeAction(this.isoline);
      }
    }
  }

  updateIsoline(data, canUpdateIsoline) {
    if (this.isoline == null) {
      this.isoline = data;
      this.newIsoline = data;
      this.isolineCalculator.reset(data);
      if (canUpdateIsoline && this.onIsolineChangeAction !== undefined) {
        this.onIsolineChangeAction(this.isoline);
      }
    } else {
      this.newIsoline = this.isolineCalculator.calculate(data);
    }
  }

  updatePixelsPointsValues() {
    if (this.actualGraphicDataBufferLength == 0) {
      return;
    }

    this.notNullSectors = [];
    this.sectorIndex = 0;
    let data = 0;
    for (let i = 0; i < this.graphicDataBuffer.length; i++) {
      data = this.getData(i);
      if (data != null) {
        this.notNullSectors.push({
          begin: i,
          end: i
        });
        this.isolineCalculator.reset(data);
        break;
      }
    }
    let isLastNull = false;
    data = this.getData(0);
    if (this.isColumnMode) {
      // create line for first point
      if (data != null) {
        const dataPixels = this.convertValueToPixels(data);
        this.columnsBuffer[0] = {
          min: dataPixels,
          max: dataPixels + 1
        };
        this.pointBuffer[1] = this.columnsBuffer[0].min;
        this.pointBuffer[3] = this.columnsBuffer[0].max;
      }
      isLastNull = data == null;

      // need this.graphicDataBufferLength > 0
      let graphicIndex = 0;
      let minY, maxY;
      let currGraphicIndex;
      let pointBufferIndex = this.graphicDataBuffer[0].graphicIndex * 4;
      let prevMinY, prevMaxY;
      for (let i = 1; i < this.actualGraphicDataBufferLength; i++) {
        currGraphicIndex = this.graphicDataBuffer[i].graphicIndex;
        data = this.getData(i);
        if (data != null) {
          data = this.convertValueToPixels(data);
        }
        if (currGraphicIndex == graphicIndex) {
          if (data != null) {
            this.notNullSectors[this.sectorIndex].end = currGraphicIndex;
            // old index
            minY = this.columnsBuffer[currGraphicIndex].min;
            maxY = this.columnsBuffer[currGraphicIndex].max;
            if (minY > data) {
              minY = data;
            } else if (maxY < data) {
              maxY = data;
            }
          }
        } else {
          if (data != null) {
            if (isLastNull) {
              this.notNullSectors.push({
                begin: currGraphicIndex,
                end: currGraphicIndex
              });
              this.sectorIndex = this.notNullSectors.length - 1;
            }

            // New index
            minY = data;
            maxY = data + 1;
            // Try remove space by height between columns (current and previous)
            prevMinY = this.columnsBuffer[graphicIndex].min;
            prevMaxY = this.columnsBuffer[graphicIndex].max;
            if (maxY < prevMinY) {
              maxY = prevMinY;
            } else if (minY > prevMaxY) {
              minY = prevMaxY;
            }
          }
          graphicIndex = currGraphicIndex;
          pointBufferIndex = currGraphicIndex * 4;
        }
        isLastNull = data == null;
        if (data != null) {
          if (maxY == minY) {
            maxY = minY + 1;
          }
          this.columnsBuffer[currGraphicIndex] = {
            min: minY,
            max: maxY
          };
          this.pointBuffer[pointBufferIndex + 1] = minY;
          this.pointBuffer[pointBufferIndex + 3] = maxY;
          //this.pointBuffer[currGraphicIndex * 4 + 1] = minY;// - this.isolineInPixels;
          //this.pointBuffer[currGraphicIndex * 4 + 3] = maxY;// - this.isolineInPixels;
        } else {
          this.pointBuffer[pointBufferIndex + 1] = 0;
          this.pointBuffer[pointBufferIndex + 3] = 0;
        }
      }
    } else {
      if (data != null) {
        data = this.convertValueToPixels(data);
        this.graphicPointsBuffer[0] = data;
      }
      // create line for first point
      for (let i = 1, prevPointIndex = 0; i < this.actualGraphicDataBufferLength; i++, prevPointIndex += 4) {
        data = this.getData(i);
        if (data != null) {
          data = this.convertValueToPixels(data);
          if (isLastNull) {
            this.notNullSectors.push({
              begin: i,
              end: i
            });
          }
          this.graphicPointsBuffer[i] = data;
          this.pointBuffer[prevPointIndex + 1] = this.graphicPointsBuffer[i - 1]; // - this.isolineInPixels; // prev
          this.pointBuffer[prevPointIndex + 3] = this.graphicPointsBuffer[i]; // - this.isolineInPixels; // curr
          isLastNull = data == null;
        }
      }
    }
    for (let i = this.actualGraphicDataBufferLength - 1; i >= 0; i--) {
      data = this.getData(i);
      if (data != null) {
        this.newIsoline = this.isolineCalculator.calculate(data);
        this.isoline = this.newIsoline;
        if (this.onIsolineChangeAction !== undefined) {
          this.onIsolineChangeAction(this.isoline);
        }
        break;
      }
    }
  }

  updatePointsValues() {
    if (this.actualGraphicDataBufferLength == 0) {
      return;
    }
    this.notNullSectors = [];
    this.sectorIndex = 0;
    for (let i = 0; i < this.graphicDataBuffer.length; i++) {
      if (this.filteredDataBuffer[i] != null) {
        this.notNullSectors.push({
          begin: i,
          end: i
        });
        this.isolineCalculator.reset(this.filteredDataBuffer[i]);
        let filteredData = this.applyFilters(this.getSourceData(i));
        for (let filterIndex = 0; filterIndex < this.settings.filters.length; filterIndex++) {
          const filter = this.settings.filters[filterIndex].filter;
          filter.reset();
          filter.settings(filteredData);
          filteredData = filter.exe(filteredData);
        }
        this.filteredDataBuffer[i] = filteredData;
        this.isolineCalculator.reset(filteredData);
        break;
      }
    }

    let isLastNull = false;
    if (this.isColumnMode) {
      let data = this.filteredDataBuffer[0];
      isLastNull = data == null;
      if (data != null) {
        // create line for first point
        const dataPixels = this.convertValueToPixels(data);
        this.columnsBuffer[0] = {
          min: dataPixels,
          max: dataPixels + 1
        };
        this.pointBuffer[1] = this.columnsBuffer[0].min; // - this.isolineInPixels;
        this.pointBuffer[3] = this.columnsBuffer[0].max; // - this.isolineInPixels;
      }

      // need this.graphicDataBufferLength > 0
      let graphicIndex = 0;
      let minY, maxY;
      let newData;
      let currGraphicIndex;
      let pointBufferIndex = this.graphicDataBuffer[0].graphicIndex * 4;
      let prevMinY, prevMaxY;
      for (let i = 1; i < this.actualGraphicDataBufferLength; i++) {
        data = this.getSourceData(i);
        if (data != null) {
          data = this.applyFilters(data);
        }
        this.filteredDataBuffer[i] = data;
        newData = this.convertValueToPixels(data);
        currGraphicIndex = this.graphicDataBuffer[i].graphicIndex;
        if (currGraphicIndex == graphicIndex) {
          if (newData != null) {
            this.notNullSectors[this.sectorIndex].end = currGraphicIndex;
            // old index
            minY = this.columnsBuffer[currGraphicIndex].min;
            maxY = this.columnsBuffer[currGraphicIndex].max;
            if (minY > newData) {
              minY = newData;
            } else if (maxY < newData) {
              maxY = newData;
            }
          }
        } else {
          if (newData != null) {
            if (isLastNull) {
              this.notNullSectors.push({
                begin: currGraphicIndex,
                end: currGraphicIndex
              });
              this.sectorIndex = this.notNullSectors.length - 1;
            }
            // New index
            minY = newData;
            maxY = newData + 1;
            // Try remove space by height between columns (current and previous)
            prevMinY = this.columnsBuffer[graphicIndex].min;
            prevMaxY = this.columnsBuffer[graphicIndex].max;
            if (maxY < prevMinY) {
              maxY = prevMinY;
            } else if (minY > prevMaxY) {
              minY = prevMaxY;
            }
          }
          graphicIndex = currGraphicIndex;
          pointBufferIndex = currGraphicIndex * 4;
          //this.newIsoline = this.isolineCalculator.calculate(filteredData);
        }
        isLastNull = newData == null;
        if (newData != null) {
          if (maxY == minY) {
            maxY = minY + 1;
          }
          this.columnsBuffer[currGraphicIndex] = {
            min: minY,
            max: maxY
          };
          this.pointBuffer[pointBufferIndex + 1] = minY;
          this.pointBuffer[pointBufferIndex + 3] = maxY;
          //this.pointBuffer[currGraphicIndex * 4 + 1] = minY;// - this.isolineInPixels;
          //this.pointBuffer[currGraphicIndex * 4 + 3] = maxY;// - this.isolineInPixels;
        }

        graphicIndex = currGraphicIndex;
      }
    } else {
      let newData = this.filteredDataBuffer[0];
      if (newData != null) {
        newData = this.convertValueToPixels(newData);
        this.graphicPointsBuffer[0] = newData;
      }
      // create line for first point
      for (let i = 1, prevPointIndex = 0; i < this.actualGraphicDataBufferLength; i++, prevPointIndex += 4) {
        this.filteredDataBuffer[i] = this.applyFilters(this.getSourceData(i));
        if (newData != null) {
          newData = this.convertValueToPixels(newData);
          if (isLastNull) {
            this.notNullSectors.push({
              begin: i,
              end: i
            });
          }
          this.graphicPointsBuffer[i] = newData;
          this.pointBuffer[prevPointIndex + 1] = this.graphicPointsBuffer[i - 1]; // - this.isolineInPixels; // prev
          this.pointBuffer[prevPointIndex + 3] = this.graphicPointsBuffer[i]; // - this.isolineInPixels; // curr
          isLastNull = newData == null;
        }
      }
    }
    for (let i = this.actualGraphicDataBufferLength - 1; i >= 0; i--) {
      let newData = this.filteredDataBuffer[i];
      if (newData != null) {
        this.newIsoline = this.isolineCalculator.calculate(newData);
        this.isoline = this.newIsoline;
        if (this.onIsolineChangeAction !== undefined) {
          this.onIsolineChangeAction(this.isoline);
        }
        break;
      }
    }
  }

  // add data without valid flag check
  // data in user units
  putData(data) {
    this._putData(data, true);
  }

  _putData(data, canUpdateIsoline) {
    this.dataIndex++;
    if (this.dataIndex == this.dataBuffer.length) {
      this.dataIndex = 0;
    }
    let filteredData = data;
    if (data == null || isNaN(data)) {
      data = null;
      filteredData = null;
    }
    if (filteredData != null) {
      for (let i = 0; i < this.settings.filters.length; i++) {
        filteredData = this.settings.filters[i].filter.exe(filteredData);
      }
      this.updateIsoline(filteredData, canUpdateIsoline);
    }
    this.signalBufferModeProvider.putData(filteredData);

    this.dataBuffer[this.dataIndex] = data;
    this.filteredDataBuffer[this.graphicDataIndex] = filteredData;
    this.graphicDataBuffer[this.graphicDataIndex] = {
      dataIndex: this.dataIndex,
      graphicIndex: this.graphicIndex
    };
    if (this.actualGraphicBufferLength < this.graphicBufferLength) {
      this.actualGraphicBufferLength = this.graphicIndex + 1;
      if (this.actualGraphicBufferLength > this.graphicBufferLength) {
        this.actualGraphicBufferLength = this.graphicBufferLength;
      }
    }
    if (this.actualGraphicDataBufferLength < this.graphicDataBufferLength) {
      this.actualGraphicDataBufferLength++;
    }
  }
}
